var Tools = require('./tools');
/*
  Nest firebase integration support

  @param options (object) {
    token     (string)   nest auth token
    removeUrl (string)   local url to hit to remove local nest integration 
    onSuccess (function) callback function to receive success?
    onRemove  (function) callback function to receive remove confirmation
    onFailure (function) callback function to handle error message display
  }
*/
module.exports = function(options) {
  
  var self = {},
      firebase = {};

  self.callback = Tools.callback;

  self.init = function() {
    self.options = options;

    if (options.token) {
      firebase = new Firebase('wss://developer-api.nest.com');
      firebase.authWithCustomToken(options.token, authHandler);
      firebase.on('value', handler, errorHandler);
    }
  };

  self.set = function(path, value) {
    firebase.child(path).set(value, errorHandler);
  };

  /* private */

  function handler(response) {
    if (response) {
      self.callback('success', [response.val()]);
    } 
    else {
      console.error('Nest response failed');
    }
  }

  /* Encountered if auth fails, removes Nest integration */
  function authHandler(error) {
    if (error) {
      firebase.off('value');
      $.ajax({ url: options.removeUrl });
      self.callback('remove', [options]);
      console.warn('Nest integration removed', error);
    }
  }

  function errorHandler(error) {
    if (error) {
      var errorObj = JSON.parse(error.message.replace(error.code + ': ', ''));
      self.callback('failure', [errorObj.message]);
    }
  }

  self.init();

  return self;

};